export enum GetStartedFeatureType {
  /*KeyFeatures = "key_features",*/
  WebFeatures = "web_testing",
  MobileWebFeatures = "mobile_web_testing",
  AndroidFeatures = "android_app_testing",
  iosFeatures = "ios_app_testing",
  /*AllFeatures = "all_tutorial"*/
}
